/**
 * Where a notification tile should take the operator.
 *
 * Not every notification is about a quote. A Copilot system alert is about a
 * whole inbox ("853 quotes in sales@… have had no movement"), so it carries no
 * quoteId — and the click handler built `/newQuotePage/undefined` from it and
 * landed on "page doesn't exist". Deciding the destination here, as a pure
 * function, keeps that judgement testable instead of buried in a click handler.
 */

const isSystemAlert = (n) =>
  n?.type === "system_alert" ||
  n?.entityType === "system" ||
  n?.entityType_ === "system";

/**
 * @param {object} notification a normalized bell notification
 * @returns {{kind: "copilot"|"notifications"|"quote", prompt?: string, quoteId?: string}}
 */
export function notificationTarget(notification) {
  if (!notification) return { kind: "notifications" };

  if (isSystemAlert(notification)) {
    // The alert's own wording tells the operator to open the copilot and ask
    // for the stale list. Rather than making them retype it, the tile asks.
    const inbox = String(notification.sourceEmail || "").trim();
    return {
      kind: "copilot",
      prompt: inbox
        ? `List the stale quotes in ${inbox} and suggest what to chase first.`
        : "List the stale quotes and suggest what to chase first.",
    };
  }

  const quoteId = String(notification.quoteId || "").trim();
  if (!quoteId) {
    // Nothing to open. The full list is a real page; an undefined quote is not.
    return { kind: "notifications" };
  }

  return { kind: "quote", quoteId };
}
